import { Message } from 'zk-ui';

import http from 'common-module/src/util/http';

import { FieldSelectOption } from '../Model/field';
import {
  IssueArea,
  IssueAssembleResponse,
  IssueFieldInfo,
  IssueSubTask,
  IssueType,
  ProjectRole,
  Sprint
} from '../Model/Issue';
import { Member } from '../Model/member';
import { ChangeRecord } from '../Model/record';
import { WorkflowInfo } from '../Model/workflow';
import { useInstance } from 'common-module/src/util/useInstance';

interface IssueAssembleFunctions {
  loadIssueData?: boolean;
  loadIssueRelationship?: boolean;
  loadIssueSubTask?: boolean;
  loadIssueType?: boolean;
  loadLayoutData?: boolean;
  loadSprint?: boolean;
}

export async function getIssueAssembleInfo(
  issueOrProjectAndType:
    | { issueId: number }
    | { projectId: number; issueTypeId?: number },
  assembleFunctions: IssueAssembleFunctions,
  cachedLastModifiedTime?: number,
  cachedLayoutLastModifiedTime?: number
): Promise<IssueAssembleResponse> {
  return http.post('/issue/issue-assemble-info', {
    ...issueOrProjectAndType,
    ...assembleFunctions,
    cachedLastModifiedTime,
    cachedLayoutLastModifiedTime
  }, {
    assertResult: (res: any) => {
      const instance = useInstance();
      if (instance && res.data.code === '008') {
        instance.showNoPermissionAlert();
        instance.eventBus.$emit('issue:closed');
        return false;
      }
      return true;
    },
    showError: false,
  });
}

export async function getIssueTypes(projectId: number): Promise<IssueType[]> {
  return http.post('/issue-type/list-selector/project-id', {
    projectId
  });
}

export async function getSprints(projectId: number): Promise<Sprint[]> {
  return http.post('/sprint/list-by-project-id-useful', {
    id: projectId
  });
}

export async function getProjectRoles(
  projectId: number
): Promise<ProjectRole[]> {
  return http.post(
    '/member/project-user-info',
    {
      projectId
    },
    {
      showError: false
    }
  );
}

export async function getSelectOptions(
  param: { projectId: number; issueTypeId: number } | { issueId: number }
): Promise<FieldSelectOption[]> {
  return http.post('/issue/more-select-options', param, { showError: false });
}

export async function updateIssue(
  id: number,
  diff: Record<string, any>
): Promise<ChangeRecord[]> {
  // return http.post('/issue/update-v2', { id, data: diff });
  return http.post('/issue/update', { id, data: diff });
}


export async function createIssue(values: Record<string, any>): Promise<{
  subtask: IssueSubTask[];
  id: number;
}> {
  try {
    const res = await http.post('/issue/add-v2', values, {
      showError: false, assertResult: (res: any) => {
        if (res.data.code !== '200') {
          const { msg, subMsg } = res.data;
          Message({
            message: subMsg,
            type: 'error',
            duration: 2000
          });
          return false;
        }
        return true;
      }
    });
    return res;
  } catch (err: any) {
    throw err;
  }
}

export async function getIssueLayout(
  projectId: number,
  issueTypeId: number
): Promise<IssueArea[]> {
  return http.post('/issue/load-layout', { projectId, issueTypeId });
}

export async function getMemberList(projectId: number): Promise<Member[]> {
  return http.post(
    '/member/project-users',
    {
      projectId,
      containAccUnEnabled: true
    },
    {
      showError: false
    }
  );
}

/**
 * 创建评论
 * @param issueId 事项ID
 * @param content 内容
 * @param commentAttributes 额外内容
 * @returns {Promise<*>}
 */
export const createComment = async (
  issueId: number,
  html: string,
  text: string,
  commentAttributes: any[],
  files: Array<{ fileKey: string; sequence: number }>
) => {
  return http.post('/sys-comment/issue/add-comment', {
    content: html,
    plainContent: text,
    linkId: issueId,
    commentAttributes,
    files
  });
};

export const getStickyTop = async (
  projectId: number,
  issueTypeId: number
): Promise<
  Array<{
    type: 'top' | 'tab_top';
    fieldCode: string;
  }>
> => {
  return http.post('/issue/user-custom-field-layout/get', {
    issueTypeId,
    projectId
  });
};
export const setStickyTop = async (
  projectId: number,
  issueTypeId: number,
  fields: Array<{
    issueTypeId: number;
    projectId: number;
    customFieldId: number;
    fieldCode: string;
    ordinate: number;
    areaName: 'right area' | 'left area';
    type: 'top' | 'tab_top';
  }>
) => {
  return http.post(
    '/issue/user-custom-field-layout/set',
    {
      projectId,
      issueTypeId,
      userCustomFieldLayoutList: fields
    },
    {
      showError: false
    }
  );
};

export async function getWorkflow(workflowId: number): Promise<WorkflowInfo> {
  return http.post(
    '/workflow/get/layout',
    {
      id: workflowId
    },
    {
      showError: false
    }
  );
}

export async function getRecentlyList(data: Object) {
  return http.post('/issue/recently-issue-list', data);
}

/* 用户最近行为上报 */
              
         export const userReportBehavior = () => {};
        
                                                        
                                                                                         
 
         
export async function getLinkPerviewInfo(url: string) {
  return http.get('page-preview/getPage', { url });
}
